import axios from "axios";
import {route} from "ziggy-js";
import {LocationResponseType} from "../model/types";

export const detectLocation = async (): Promise<LocationResponseType> => {
    const {data} = await axios.post(route("location.detection"));

    return data;
};
